import Positions from '@polestar/component-warehouse-react/tokens/positions/Positions';
import { CrossAxisAlignments, MainAxisAlignments, } from '@polestar/component-warehouse-react/tokens/alignments/Alignments';
export const calculatePosition = ({ placement, baseLeft, baseTop, attachedHeight, attachedWidth, clientWidth, isRTL, }) => {
    const [position, alignment] = placement.split(' ');
    const verticalPlaced = position === 'top' || position === 'bottom';
    let top = baseTop;
    let left = baseLeft;
    let width = 0;
    let height = 0;
    let mainAxisAlignment = MainAxisAlignments.start;
    let crossAxisAlignment = CrossAxisAlignments.end;
    if (verticalPlaced) {
        width = attachedWidth;
        if (position === 'bottom') {
            top = baseTop + attachedHeight;
            crossAxisAlignment = CrossAxisAlignments.start;
        }
        if (alignment === 'left') {
            mainAxisAlignment = MainAxisAlignments.end;
        }
        else if (alignment === 'center') {
            mainAxisAlignment = MainAxisAlignments.center;
        }
        if (isRTL) {
            left = clientWidth - baseLeft - attachedWidth;
        }
        if (alignment === 'middle') {
            mainAxisAlignment = MainAxisAlignments.center;
            width = clientWidth;
            left = 0;
        }
    }
    else {
        height = attachedHeight;
        if (position === 'right') {
            mainAxisAlignment = MainAxisAlignments.start;
            left = baseLeft + attachedWidth;
        }
        else if (position === 'left') {
            mainAxisAlignment = MainAxisAlignments.end;
        }
        if (alignment === 'bottom') {
            crossAxisAlignment = CrossAxisAlignments.start;
        }
        else if (alignment === 'center') {
            crossAxisAlignment = CrossAxisAlignments.center;
        }
        if (isRTL) {
            left = clientWidth - baseLeft - attachedWidth;
            if (position === 'right') {
                left = clientWidth - baseLeft;
            }
        }
        if (alignment === 'middle') {
            mainAxisAlignment = MainAxisAlignments.center;
            width = clientWidth;
            left = 0;
        }
    }
    return { top, left, width, height, mainAxisAlignment, crossAxisAlignment };
};
export const getPlacements = ({ preferredPlacementArray, attachedLeft, attachedTop, attachedWidth, attachedHeight, clientWidth, clientHeight, popoverHeight, popoverWidth, isRTL, }) => {
    const areas = [
        // Top
        {
            placement: isRTL ? Positions.topRight : Positions.topLeft,
            area: [attachedLeft + attachedWidth, attachedTop],
            outOfView: attachedTop - popoverHeight <= 0 || attachedLeft + attachedWidth - popoverWidth < 0,
        },
        {
            placement: Positions.topCenter,
            area: [
                Math.min((attachedLeft + attachedWidth / 2) * 2, (clientWidth - (attachedLeft + attachedWidth / 2)) * 2),
                attachedTop,
            ],
            outOfView: attachedTop - popoverHeight <= 0 || attachedLeft - (popoverWidth - attachedWidth) / 2 < 0,
        },
        {
            placement: isRTL ? Positions.topLeft : Positions.topRight,
            area: [clientWidth - attachedLeft, attachedTop],
            outOfView: attachedTop - popoverHeight <= 0 || attachedLeft < 0,
        },
        // Right
        {
            placement: isRTL ? Positions.leftTop : Positions.rightTop,
            area: [clientWidth - (attachedLeft + attachedWidth), attachedTop + attachedHeight],
            outOfView: attachedTop + attachedHeight - popoverHeight < 0,
        },
        {
            placement: isRTL ? Positions.leftCenter : Positions.rightCenter,
            area: [
                clientWidth - (attachedLeft + attachedWidth),
                Math.min((attachedTop + attachedHeight / 2) * 2, (clientHeight - (attachedTop + attachedHeight / 2)) * 2),
            ],
            outOfView: attachedTop - (popoverHeight - attachedHeight) / 2 < 0,
        },
        {
            placement: isRTL ? Positions.leftBottom : Positions.rightBottom,
            area: [clientWidth - (attachedLeft + attachedWidth), clientHeight - attachedTop],
            outOfView: attachedTop < 0,
        },
        // Bottom
        {
            placement: isRTL ? Positions.bottomLeft : Positions.bottomRight,
            area: [clientWidth - attachedLeft, clientHeight - (attachedTop + attachedHeight)],
            outOfView: attachedTop + popoverHeight >= clientHeight ||
                popoverWidth > clientWidth - attachedLeft ||
                popoverHeight > clientHeight - (attachedTop + attachedHeight) ||
                attachedLeft < 0 ||
                attachedTop + attachedHeight < 0,
        },
        {
            placement: Positions.bottomCenter,
            area: [
                Math.min((attachedLeft + attachedWidth / 2) * 2, (clientWidth - (attachedLeft + attachedWidth / 2)) * 2),
                clientHeight - (attachedTop + attachedHeight),
            ],
            outOfView: attachedTop + popoverHeight >= clientHeight ||
                attachedLeft - (popoverWidth - attachedWidth) / 2 < 0 ||
                attachedTop + attachedHeight < 0,
        },
        {
            placement: isRTL ? Positions.bottomRight : Positions.bottomLeft,
            area: [attachedLeft + attachedWidth, clientHeight - (attachedTop + attachedHeight)],
            outOfView: attachedTop + popoverHeight >= clientHeight ||
                attachedLeft + attachedWidth - popoverWidth < 0 ||
                attachedTop + attachedHeight < 0,
        },
        // Left
        {
            placement: isRTL ? Positions.rightBottom : Positions.leftBottom,
            area: [attachedLeft, clientHeight - attachedTop],
            outOfView: attachedTop < 0 || attachedTop > clientHeight,
        },
        {
            placement: isRTL ? Positions.rightCenter : Positions.leftCenter,
            area: [
                attachedLeft,
                Math.min((attachedTop + attachedHeight / 2) * 2, (clientHeight - (attachedTop + attachedHeight / 2)) * 2),
            ],
            outOfView: attachedTop - (popoverHeight - attachedHeight) / 2 < 0,
        },
        {
            placement: isRTL ? Positions.rightTop : Positions.leftTop,
            area: [attachedLeft, attachedTop + attachedHeight],
            outOfView: attachedTop + attachedHeight > clientHeight,
        },
    ];
    return preferredPlacementArray.reduce((carry, placement) => {
        const { 
        // amount of space that is available until the borders of the viewport from the starting position
        area: [areaWidth, areaHeight], outOfView = false, } = areas.find((area) => area.placement === placement) || { area: [0, 0] };
        const widthDelta = areaWidth > 0 ? areaWidth / popoverWidth : -1;
        const heightDelta = areaHeight > 0 ? areaHeight / popoverHeight : -1;
        carry[placement] = {
            fits: !outOfView && widthDelta >= 1 && heightDelta >= 1,
            widthDelta,
            heightDelta,
        };
        return carry;
    }, {});
};
